import store from "../../store";
import api from "../request";
import apiOmr from "../requestOmr";
import qs from "qs";
import { Promise } from "q";


function getActiveInstituteList(reqData) {
  return api.post("institute/active-list", { reqData }).then(({ data }) => {
    return data;
  });
}

function getTestList(reqData) {
  return api.post("test/list", { reqData }).then(({ data }) => {
    return data;
  });
}
function getScheduleTestList(reqData) {
  return api.post("test/schedule-list", { reqData }).then(({ data }) => {
    return data;
  });
}
function schedule(reqData) {
  return api.post("test/schedule", { reqData }).then(({ data }) => {
    return data;
  });
}
function share(reqData) {
  return api.post("test/share", { reqData }).then(({ data }) => {
    return data;
  });
}
function getLiveStudents(reqData) {
  return api.post("test/live-tracking", { reqData }).then(({ data }) => {
    return data;
  });
}
function assignTest(reqData) {
  return api.post("test/assign-test", { reqData }).then(({ data }) => {
    return data;
  });
}
function assignTestStatus(reqData) {
  return api
    .get("test/assign-test-status/" + reqData.testId)
    .then(({ data }) => {
      return data;
    });
}
function createTest(reqData) {
  return api.post("questions/custom/create", { reqData }).then(({ data }) => {
    return data;
  });
}
function getTestPreviewDetails(reqData) {
  return api.post("test/start", { reqData }).then(({ data }) => {
    return data;
  });
}

function getLiveTestDetails(reqData) {
  return api.post("test/start-live", { reqData }).then(({ data }) => {
    return data;
  });
}

function updateProgressInDB(reqData) {
  return api.post("test/update-progress", { reqData }).then(({ data }) => {
    return data;
  });
}
function updateHeartBeat(reqData) {
  return api
    .post(
      "test/heart-beat",
      { reqData },
      {
        cancelToken:
          reqData.beat && reqData.beat.token ? reqData.beat.token : null,
      }
    )
    .then(({ data }) => {
      return data;
    });
}

function getInstructions(reqData) {
  return api.post("test/check", { reqData }).then(({ data }) => {
    return data;
  });
}

function getPastTestList(reqData) {
  return api.post("test/past-test", { reqData }).then(({ data }) => {
    return data;
  });
}
function getTestResultsList(reqData) {
  return api.post("test/-", { reqData }).then(({ data }) => {
    return data;
  });
}
function updateTestInstructions(reqData) {
  return api.post("test/update-instructions", { reqData }).then(({ data }) => {
    return data;
  });
}
function remainingTime(reqData) {
  return api.post("test/get-remaining-time", { reqData }).then(({ data }) => {
    return data;
  });
}
function updateTestName(reqData) {
  return api.post("test/update-test-info", { reqData }).then(({ data }) => {
    return data;
  });
}

function getQuestions(reqData) {
  return api.post("test/questions", { reqData }).then(({ data }) => {
    return data;
  });
}
function applyBonus(reqData) {
  return api.post("test/apply-bonus", { reqData }).then(({ data }) => {
    return data;
  });
}

function reevaluateMarks(reqData) {
  return api.post("test/re-calculate-marks", { reqData }).then(({ data }) => {
    return data;
  });
}

function createDuplicateTest(reqData) {
  return api.post("test/duplicate", { reqData }).then(({ data }) => {
    return data;
  });
}

function deleteTestById(reqData) {
  return api.post("test/delete", { reqData }).then(({ data }) => {
    return data;
  });
}
function uploadAndReplaceQuestion(reqData) {
  return api
    .post("test/upload-and-replace-question", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function createCustomTest(reqData) {
  return api.post("test/custom-create", { reqData }).then(({ data }) => {
    return data;
  });
}
function searchAnotherQuestion(reqData) {
  return api.post("questions/get-sorted-list", { reqData }).then(({ data }) => {
    return data;
  });
}

function replaceTestQuestion(reqData) {
  return api
    .post("test/replace-test-question", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getBucketQuestion(reqData) {
  return api
    .post("questions/get-bucket-questions", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function addBucketQuestion(reqData) {
  return api
    .put(`questions/add-bucket-questions/${reqData.test_detail_id}`, {
      reqData,
    })
    .then(({ data }) => {
      return data;
    });
}
function removeBucketQuestion(reqData) {
  return api
    .put(`questions/remove-bucket-questions/${reqData.test_detail_id}`, {
      reqData,
    })
    .then(({ data }) => {
      return data;
    });
}
function approveTest(reqData) {
  return api.post(`test/approve-test`, { reqData }).then(({ data }) => {
    return data;
  });
}
function getPastTestTeacher(reqData) {
  return api.post(`test/past-test-teacher`, { reqData }).then(({ data }) => {
    return data;
  });
}
function getTestQuestionData(reqData) {
  return api
    .post(`test/get-test-question-data`, { reqData })
    .then(({ data }) => {
      return data;
    });
}
function deleteTest(reqData) {
  return api.post("test/soft-delete", { reqData }).then(({ data }) => {
    return data;
  });
}
function customTestRetry(reqData) {
  return api.post("test/custom-test-retry", { reqData }).then(({ data }) => {
    return data;
  });
}
function checkTestStatus(reqData) {
  return api.post("test/check-status", { reqData }).then(({ data }) => {
    return data;
  });
}
function createTestForPracticeSession(reqData) {
  return api
    .post("test/create-practice-session", { reqData })
    .then(({ data }) => {
      return data;
    });
}
//Integrating add & remove Bookmark API.
function addBookmarkQuestion(reqData) {
  return api.post(`questions/add-bookmark`, { reqData }).then(({ data }) => {
    return data;
  });
}
function getQuestionOptions(reqData) {
  return api.post(`questions/options`, { reqData }).then(({ data }) => {
    return data;
  });
}
function getTestForPracticeSession(reqData) {
  return api
    .post("test/get-practice-session-questions", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function removeBookmarkQuestion(reqData) {
  return api.post(`questions/remove-bookmark`, { reqData }).then(({ data }) => {
    return data;
  });
}
function getBookmarkQuestion(reqData) {
  return api.post(`questions/get-bookmark`, { reqData }).then(({ data }) => {
    return data;
  });
}
function getAttemptedQuestions(reqData) {
  return api.post(`questions/get-attempted`, { reqData }).then(({ data }) => {
    return data;
  });
}
function updateTestForPracticeSession(reqData) {
  return api
    .post("test/update-progress-practice-session", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function improvementAssignmentList(reqData) {
  return api
    .post("test/get-improvement-assignment-list", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function improvementAssignmentQueLoad(reqData) {
  return api
    .post("test/load-improvement-assignment", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getTestForImprovementAssignment(reqData) {
  return api
    .post("test/get-improvement-assignment-questions", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function updateTestForImprovementAssignment(reqData) {
  return api
    .post("test/update-improvement-assignment-status", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getPracticeSessionList(reqData) {
  return api
    .post("test/get-practice-session-list", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getTestReportsList(reqData) {
  return api
    .post("test/get-report-list", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function testAttempted(reqData) {
  return api
    .post("test/check-test-attempted", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getQuesDateAndViewCountOfLastCreQues(reqData) {
  return api.post(`questions/get-question-count-and-created-at`, { reqData }).then(({ data }) => {
    return data;
  });
}
function saveEvent(reqData) {
  return api
    .post("activities/duration/save-event", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getCustomTestCount(reqData) {
  return api
    .post("test/get-custom-test-count", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function autoSubmit(reqData) {
  return api
    .post("test/auto-submit", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function logData(reqData) {
  let logData = JSON.stringify(reqData);
  return api.get(`test/log-test-data?logData=${logData}&user_id=${reqData.user_id}&type=${reqData.type}`)
  .then(({ data }) => {
      return data;
    });
}
function createMytTest(reqData) {
  return api
    .post("myt-test/custom-create", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getMYTTestList(reqData) {
  return api
    .post("myt-test/list", { reqData })
    .then(({ data }) => {
      return data;
    });
}


function getMYTPreviewDetails(reqData) {
  return api
    .post("myt-test/start", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function saveTemplate(formData) {
  return api
      .post("myt-test/save-template", formData, {
          headers: {
              "Content-Type": "multipart/form-data",
          },
      })
      .then(({ data }) => {
          return data;
      })
      .catch(({ data }) => {
          return Promise.reject(data);
      });
}
function getTemplate(reqData) {
  return api
    .post("myt-test/get-template", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getSimilarQuestions(reqData) {
  return api
    .post("myt-questions/get-sorted-list", { reqData })
    .then(({ data }) => {
      return data;
    });
  }
  function getInstituteSimilarQuestions(reqData) {
    return api
      .post("questions/get-similar-questions", { reqData })
      .then(({ data }) => {
        return data;
      });
    }

function replaceQuestion(reqData) {
  return api
    .post("myt-test/replace-test-question", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function replaceInstituteQuestion(reqData) {
  return api
    .post("test/replace-test-question", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function uploadAndReplaceMytQuestion(reqData) {
  return api
    .post("myt-test/upload-and-replace-question", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getQuestionUsageDetails(reqData) {
  return api
    .post("myt-test/question-usage-data", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function searchAnotherMytQuestion(reqData) {
  return api
    .post("myt-questions/search-another-question", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function removeTemplate(reqData) {
  return api
    .post("myt-test/remove-template", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function testCreationLimit(reqData){
  return api
  .post("myt-test/unpaid-test", { reqData })
  .then(({ data }) => {
      return data;
  });
}
function getTabChangeCount(reqData) {
  return api
    .get(`test/tab-change-count?user_id=${reqData.user_id}&test_id=${reqData.test_id}`)
    .then(({ data }) => {
      return data;
    });
}
function getPastTestInstituteList(reqData) {
  return api
    .post("test/past-test-institute", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function deleteScheduleTest(reqData) {
  return api
    .post("test/schedule-delete", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getOmrDetailsTestWise(reqData) {
  return api
    .post("omr/get", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function getUnassessedOmrDetails(reqData) {
  return api
    .post("omr/get-unassessed-omr", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function deleteOmr(reqData) {
  return api
    .post("omr/delete", { reqData })
    .then(({ data }) => {
      return data;
    });
}
function uploadOmr(formData) {
  return apiOmr
    .post("omr-upload", formData, {
      headers: {
          "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => {
      return data;
    });
}

function getOmrDetail(reqData) {
  return api
    .post("omr/get-detail", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function getOmrById(id) {
  return api
    .get("omr/get/"+id)
    .then(({ data }) => {
      return data;
    });
}
function recycleOmr(reqData) {
  return api
    .post("omr/reassess", { reqData })
    .then(({ data }) => {
      return data;
    });
  }

function getTestDownloadSettings(reqData) {
  return api
    .get("test/test-download-settings/"+reqData.test_id)
    .then(({ data }) => {
      return data;
    });
}
function downloadTest(url) {
  return api
    .get(url)
    .then(({ data }) => {
      return data;
    });
}
function getDownloadStatus(reqData) {
  return api
    .post('test/test-download-status',{reqData})
    .then(({ data }) => {
      return data;
    });
}
function deleteDownloadData(reqData) {
  return api
    .post('test/delete-test-pdf',{reqData})
    .then(({ data }) => {
      return data;
    });
}
function getOmrDetailsById(id) {
  return api
    .get(`omr/get/${id}`)
    .then(({ data }) => {
      return data;
    });
}
function editOmrResponseData(reqData) {
  return api
    .put(`omr/edit-omr-response/${reqData.id}`, { reqData })
    .then(({ data }) => {
      return data;
    });
}

export default {
  share,
  getActiveInstituteList,
  getTestList,
  schedule,
  getLiveStudents,
  assignTest,
  assignTestStatus,
  getScheduleTestList,
  createTest,
  getTestPreviewDetails,
  getLiveTestDetails,
  updateProgressInDB,
  updateHeartBeat,
  getInstructions,
  getPastTestList,
  getTestResultsList,
  updateTestInstructions,
  remainingTime,
  updateTestName,
  getQuestions,
  applyBonus,
  reevaluateMarks,
  createDuplicateTest,
  deleteTestById,
  uploadAndReplaceQuestion,
  createCustomTest,
  searchAnotherQuestion,
  replaceTestQuestion,
  getBucketQuestion,
  addBucketQuestion,
  removeBucketQuestion,
  approveTest,
  getPastTestTeacher,
  getTestQuestionData,
  deleteTest,
  customTestRetry,
  checkTestStatus,
  createTestForPracticeSession,
  getTestForPracticeSession,
  addBookmarkQuestion,
  getQuestionOptions,
  removeBookmarkQuestion,
  getBookmarkQuestion,
  getAttemptedQuestions,
  updateTestForPracticeSession,
  improvementAssignmentList,
  improvementAssignmentQueLoad,
  getTestForImprovementAssignment,
  updateTestForImprovementAssignment,
  getPracticeSessionList,
  getTestReportsList,
  testAttempted,
  getQuesDateAndViewCountOfLastCreQues,
  saveEvent,
  getCustomTestCount,
  autoSubmit,
  logData,
  createMytTest,
  getMYTTestList,
  getMYTPreviewDetails,
  saveTemplate,
  getTemplate,
  getSimilarQuestions,
  getInstituteSimilarQuestions,
  replaceQuestion,
  replaceInstituteQuestion,
  uploadAndReplaceMytQuestion,
  getQuestionUsageDetails,
  searchAnotherMytQuestion,
  removeTemplate,
  testCreationLimit,
  getTabChangeCount,
  getPastTestInstituteList,
  deleteScheduleTest,
  getOmrDetailsTestWise,
  getUnassessedOmrDetails,
  deleteOmr,
  uploadOmr,
  getOmrDetail,
  getOmrById,
  recycleOmr,
  getTestDownloadSettings,
  downloadTest,
  getDownloadStatus,
  deleteDownloadData,
  getOmrDetailsById,
  editOmrResponseData
};
